const SiteTemplate = () =>
  import(
    /* webpackChunkName: "site-template" */ '@/pages/site-generator/site/template/index.vue'
  )

const CreateSiteTemplate = () =>
  import(
    /* webpackChunkName: "site-template" */ '@/pages/site-generator/site/template/create.vue'
  )
const EditSiteTemplate = () =>
  import(
    /* webpackChunkName: "site-template" */ '@/pages/site-generator/site/template/edit.vue'
  )

const DetailTemplate = () =>
  import(
    /* webpackChunkName: "site-site" */ '@/pages/site-generator/site/template/detail.vue'
  )

export default {
  path: 'template',
  meta: {
    label: 'template',
    auth: 'template'
  },
  component: {
    name: 'Template',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SiteTemplateReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: SiteTemplate
    },
    {
      name: 'SiteCreateTemlate',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateSiteTemplate
    },
    {
      name: 'SiteEditTemplate',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditSiteTemplate,
      props: true
    },
    {
      name: 'SiteDetailTemplate',
      path: 'detail/:id',
      meta: {
        label: 'detail',
        auth: 'report'
      },
      component: DetailTemplate,
      props: true
    }
  ]
}
